var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "quick-dropdown-filter position-relative",
    class: _vm.$attrs.class
  }, [_c('button', {
    staticClass: " dropdown-toggle btn btn-light d-flex align-items-center  gap-1 ps-3 pe-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.label) + " : ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 text-start"
  }, [_vm._v(" " + _vm._s(_vm.selected) + " ")])]), _vm.isOpen ? _c('ul', {
    staticClass: "dropdown-menu show w-100",
    staticStyle: {
      "position": "absolute",
      "top": "70%",
      "left": "0",
      "z-index": "10"
    }
  }, _vm._l(_vm.options, function (option, index) {
    return _c('li', {
      key: index,
      staticClass: "dropdown-item",
      class: {
        option: option !== _vm.modelValue,
        'selected-option': option === _vm.modelValue
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.selectOption(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option) + " ")]);
  }), 0) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }